module.exports = __webpack_public_path__ + "static/Symphonia1-c04b07abb547e275922441220cfea6db.webp";